import { createContext, useContext, useState, useEffect } from 'react';
import api from '../lib/api';
import { useAuth } from './AuthContext';

const AdminClientContext = createContext();

export const useAdminClient = () => {
  const context = useContext(AdminClientContext);
  if (!context) {
    throw new Error('useAdminClient must be used within AdminClientProvider');
  }
  return context;
};

export const AdminClientProvider = ({ children }) => {
  const { user } = useAuth();
  const [selectedClientId, setSelectedClientIdState] = useState(() => {
    try {
      return localStorage.getItem('synpop_admin_active_client') || null;
    } catch {
      return null;
    }
  });
  const [allClients, setAllClients] = useState([]);

  const setSelectedClientId = (id) => {
    setSelectedClientIdState(id);
    try {
      if (id) localStorage.setItem('synpop_admin_active_client', id);
      else localStorage.removeItem('synpop_admin_active_client');
    } catch {
      // ignore quota / privacy errors
    }
  };

  useEffect(() => {
    // Fetch clients only for admin users
    const fetchClients = async () => {
      if (user?.is_admin) {
        try {
          const response = await api.get('/admin/clients');
          setAllClients(response.data);
        } catch (error) {
          // Silent fail - admin client fetch is optional
          setAllClients([]);
        }
      } else {
        setSelectedClientId(null);
        setAllClients([]);
      }
    };
    
    fetchClients();
  }, [user]);

  const value = {
    selectedClientId,
    setSelectedClientId,
    allClients,
    activeClient: allClients.find(c => c.id === selectedClientId),
    isAdmin: user?.is_admin || false
  };

  return (
    <AdminClientContext.Provider value={value}>
      {children}
    </AdminClientContext.Provider>
  );
};
